import { render, staticRenderFns } from "./LaMa.vue?vue&type=template&id=0c0e91da&"
import script from "./LaMa.vue?vue&type=script&lang=js&"
export * from "./LaMa.vue?vue&type=script&lang=js&"
import style0 from "./LaMa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports